const normalizeString = (value) => (typeof value === 'string' ? value.trim() : '')

const extractWordsArray = (parsed) => {
	if (Array.isArray(parsed)) return parsed
	if (parsed && Array.isArray(parsed.words)) return parsed.words
	return null
}

export const parseBulkWordsJson = (rawJson, existingWords = []) => {
	if (!rawJson?.trim()) {
		return { items: [], error: null }
	}

	let parsed
	try {
		parsed = JSON.parse(rawJson)
	} catch {
		return { items: [], error: 'Invalid JSON format' }
	}

	const wordsArray = extractWordsArray(parsed)
	if (!wordsArray) {
		return { items: [], error: 'JSON must be an array of words or { "words": [...] }' }
	}

	const existingSet = new Set(existingWords.map((card) => card.word?.toLowerCase()).filter(Boolean))
	const seenInImport = new Set()

	const items = wordsArray.map((entry) => {
		const word = normalizeString(entry?.word)
		const translate = normalizeString(entry?.translate)
		const example = normalizeString(entry?.example)
		const isValid = word.length > 0 && translate.length > 0
		const wordKey = word.toLowerCase()
		const isDuplicate = isValid && (existingSet.has(wordKey) || seenInImport.has(wordKey))

		if (isValid) seenInImport.add(wordKey)

		return {
			word,
			translate,
			example,
			isValid,
			isDuplicate,
			selected: isValid && !isDuplicate
		}
	})

	return { items, error: null }
}

export const BULK_IMPORT_JSON_EXAMPLE = `[
  {
    "word": "apple",
    "translate": "яблоко",
    "example": "I eat an apple every day."
  },
  {
    "word": "run",
    "translate": "бежать",
    "example": "I run every morning."
  }
]`
